import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Mise en page « téléphone » de la boutique.
 *
 * Petit écran (< 768 px) OU écran TACTILE jusqu'à la taille d'une tablette.
 * Demande de Philippe (27/09/2026) : sur iPad, la boutique prenait la mise en
 * page d'ordinateur (barre latérale, panier à droite, petits liens) — pensée
 * pour la souris. Un iPad se tient comme un grand téléphone : barre du bas,
 * bouton « Rayons & filtres » sous le pouce, grille à 3-4 colonnes (elle suit
 * déjà la largeur). `hover: none` + `pointer: coarse` = un doigt, pas une
 * souris ; un iPad utilisé avec clavier et trackpad retrouve la mise en page
 * d'ordinateur.
 */
function requete(breakpoint: number): string {
  return `(max-width: ${breakpoint - 1}px), (hover: none) and (pointer: coarse) and (max-width: 1400px)`;
}

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(requete(breakpoint)).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(requete(breakpoint));
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
}
